import React, { useState } from "react";
import { Row, Col, Modal, Table, Button, Form, Alert } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import ConversionActionIds from "./ConversionActionIds";
import CustomTooltip from "utils/CustomTooltip";
import testCampaignGroupFilters from "utils/testCampaignGroupFilters";
import CustomConversions from "client_config/ppc_config/social/ids_data/CustomConversions";

export default function ConfigureCampaignGroup(props) {
  const [showBox, setShowBox] = useState(false);
  const clearFields = (item, input) => {
    document.getElementById(`${item}`).value = "";
  };
  const [testString, setTestString] = useState("");
  const testStringMatches = testCampaignGroupFilters({ contains: { [props.containsPreviewModifier]: props.containsTerms }, notContains: { [props.notContainsPreviewModifier]: props.notContainsTerms } }, testString) == true
  const [conversionActionsEnabled, setConversionActionsEnabled] = useState(false);
  const [conversionActions, setConversionActions] = useState([{ conversion_type: "exclusive", name: "", conversion_id: "" }]);
  // Only used for social
  const [conversionObjective, setConversionObjective] = useState(props.social_section.conversion_objective);
  const [customConversions, setCustomConversions] = useState([]);
  const [tiktokConversionObjective, setTiktokConversionObjective] = useState(props.social_section.tiktok_conversion_objective);
  // Error handling
  const [errorText, setErrorText] = useState([]);
  
  const handleSumbit = (e) => {
    e.preventDefault();
    
    const newName = $(".campaign-name").val();
    const conversionActionsLabels = $(".conversion-actions-label").map(function() { return $(this).val(); }).toArray();
    const conversionActionsIds = $(".conversion-actions-id").map(function() { return $(this).val(); }).toArray();
    const customConversionsLabels = $(".social-custom-conversions-label").map(function() { return $(this).val(); }).toArray();
    const customConversionsIds = $(".social-custom-conversions-id").map(function() { return $(this).val(); }).toArray();
    let errorsPresent = false;
    let errors = [];

    if (newName === undefined || newName === "") {
      errorsPresent = true;
      errors.push("You must include a campaign group name")
    }
    if (conversionActionsEnabled && conversionActions.length > 0 && conversionActionsLabels.includes("")) {
      errorsPresent = true;
      errors.push("All conversion actions must have a label")
    }
    if (conversionActionsEnabled && conversionActions.length > 0 && conversionActionsIds.includes("")) {
      errorsPresent = true;
      errors.push("All conversion actions must have an ID")
    }
    // check the props if this is the social section
    if (props.platformType === "Social" && conversionObjective === "custom_conversions" && customConversions.length > 0 && customConversionsLabels.includes("")) {
      errorsPresent = true;
      errors.push("All custom conversions must have a label")
    }
    if (props.platformType === "Social" && conversionObjective === "custom_conversions" && customConversions.length > 0 && customConversionsIds.includes("")) {
      errorsPresent = true;
      errors.push("All custom conversions must have an ID")
    }

    setErrorText(errors);

    if (!errorsPresent) {
      setErrorText([])
      props.handleAddBox(conversionActions, conversionActionsEnabled, customConversions, conversionObjective, tiktokConversionObjective);
      setShowBox(false);
      props.setContainsTerms([]);
      props.setNotContainsTerms([]);
      props.setCampaignGroupsNames([]);
      setConversionActionsEnabled(false);
      setConversionActions([{ conversion_type: "exclusive", name: "", conversion_id: "" }]);
      setConversionObjective(props.social_section.conversion_objective);
      setCustomConversions([]);
      setTiktokConversionObjective(props.social_section.tiktok_conversion_objective);
    }
  };

  return (
    <div>
      <div className="mt-3 mt-md-0 center-from-right">
        <Button
          onClick={(e) => setShowBox(true)}
          className="btn-lg"
          style={{
            cursor: "pointer",
            paddingLeft: "26px",
            paddingRight: "26px",
          }}
          variant="success">
          + New campaign group
        </Button>
      </div>
      {/* Popup Modal */}
      <Modal className="campaign-modal" show={showBox} onHide={(e) => setShowBox(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="center-it">Configure Campaign Groups</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="cg-col" lg={7} xs={12}>
              <Row className="align-items-center mb-3 mt-3">
                <Col md={1}>
                  <p className="f16  visby-bold  primary">Name:</p>
                </Col>
                <Col md={8} className="pl-3 pl-md-5 collapse-padding-mobile campaign-name-box">
                  <Form.Control
                    style={{ width: "368px" }}
                    className="campaign-name"
                    size="md"
                    onChange={(e) => props.setCampaignGroupsNames([...props.campaignGroupsNames, e.target.value])}
                    placeholder={`${props.platformType}: Campaign Group Name`}
                    required
                  />
                </Col>
              </Row>

              <Row className="filter-terms">
                <Col>
                  <p className="f16 visby-bold  primary pb-2 pr-5"> Contains:</p>
                  <div>
                    <Form.Control
                      style={{ width: "200px" }}
                      name="contains_term"
                      size="sm"
                      placeholder="Type term here..."
                      onFocus={(e) => {
                        props.setShowAlert1(false);
                      }}
                      onChange={(e) => {
                        props.setContainsInput(e.target.value);
                      }}
                      id="contains_term"
                    />
                  </div>
                  {props.showAlert1 === true ? (
                    <Alert className="mt-3 over-modal fade show" variant="danger">
                      <Row>
                        <Col className="pr-0 pt-2 pb-3">
                          {props.containsInput !== "" ? (
                            <>
                              <p className="pl-3 pt-3">
                                The keyword "<strong>{props.containsInput}</strong>" already exists!
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="pl-3 pt-3">You must include a term!</p>
                            </>
                          )}
                        </Col>
                        <Col md={3}>
                          <p
                            style={{ cursor: "pointer" }}
                            className="f20 pr-2"
                            onClick={(e) => {
                              props.setShowAlert1(false);
                              props.setContainsInput("");
                            }}>
                            x
                          </p>
                        </Col>
                      </Row>
                    </Alert>
                  ) : undefined}
                  <div className="text-center text-md-left add-term-btn ">
                    <Button
                      style={{
                        paddingLeft: "25px",
                        paddingRight: "25px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                      }}
                      variant="success"
                      className="my-3 btn-sm"
                      onClick={() => {
                        props.addItem(props.containsInput, "contains");
                        clearFields("contains_term");
                        {
                          props.showAlert1 === true && props.setContainsInput("");
                        }
                      }}>
                      + Add term
                    </Button>
                  </div>
                  <div className="term-box  p-3">
                    {props.containsTerms.map((term, idx) => {
                      return (
                        <div key={`contains-term-${idx}`} className="mb-2 term d-inline-block">
                          <span className="primary">{term}</span>
                          <span
                            style={{ color: "#808080", cursor: "pointer" }}
                            className="pl-3 "
                            onClick={(e) => {
                              props.removeItem(term, "contains");
                              props.setShowAlert1(false);
                            }}>
                            x
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </Col>
                <Col>
                  <p className="f16 pb-2  visby-bold primary"> Does not contain:</p>
                  <div>
                    <Form.Control
                      style={{ width: "200px" }}
                      name="does_not_contain_term"
                      id="does_not_contain_term"
                      size="sm"
                      placeholder="Type term here..."
                      onFocus={(e) => {
                        props.setShowAlert2(false);
                      }}
                      onChange={(e) => props.setNotContainsInput(e.target.value)}
                    />
                    {props.showAlert2 === true ? (
                      <Alert className="mt-3 over-modal fade show" variant="danger">
                        <Row>
                          <Col className="pr-0 pt-2 pb-3">
                            {props.notContainsInput === "" ? (
                              <p className="pl-3 pt-3">You must include a term!</p>
                            ) : (
                              <>
                                <p className="pl-3 pt-3">
                                  The keyword "<strong>{props.notContainsInput}</strong>" already exists!
                                </p>
                              </>
                            )}
                          </Col>
                          <Col md={3}>
                            <p
                              style={{ cursor: "pointer" }}
                              className="f20 pr-2"
                              onClick={(e) => {
                                props.setShowAlert2(false);
                                props.setContainsInput("");
                              }}>
                              x
                            </p>
                          </Col>
                        </Row>
                      </Alert>
                    ) : undefined}
                  </div>
                  <div className="add-term-btn text-center text-md-left ">
                    <Button
                      style={{
                        paddingLeft: "25px",
                        paddingRight: "25px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                      }}
                      variant="success"
                      className="my-3 btn-sm"
                      onClick={() => {
                        props.addItem(props.notContainsInput, "notContains");
                        clearFields("does_not_contain_term");
                        {
                          props.showAlert2 === true && props.setNotContainsInput("");
                        }
                      }}>
                      + Add term
                    </Button>
                  </div>
                  <div className="p-3 term-box">
                    {props.notContainsTerms.map((term, idx) => {
                      return (
                        <div key={`notContains-term-${idx}`} className="mb-2 term d-inline-block">
                          <span className="primary">{term}</span>
                          <span
                            style={{ color: "#808080", cursor: "pointer" }}
                            className="pl-3 "
                            onClick={() => {
                              props.removeItem(term, "notContains");
                              props.setShowAlert2(false);
                            }}>
                            x
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Row className="my-3 align-items-center">
                    <Col className={props.onboarding ? "mr-4" : "mr-2"}>
                      <p style={{ whiteSpace: "nowrap" }} className="f14 text-center primary nunito-regular">
                        "Contains" modifier:
                      </p>
                    </Col>
                    <Col>
                      <Form.Control
                        className="primary "
                        onChange={(e) => props.setContainsPreviewModifier(e.target.value)}
                        size="sm"
                        as="select"
                        value={props.containsPreviewModifier}
                        style={{ width: "70px" }}>
                        <option value="and">and</option>
                        <option value="or">or</option>
                      </Form.Control>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row className="my-3 align-items-center">
                    <Col className={props.onboarding ? "mr-4 pl-0" : "mr-2"}>
                      <p style={{ whiteSpace: "nowrap" }} className="f14 primary text-center nunito-regular">
                        "Not contains" modifier:
                      </p>
                    </Col>
                    <Col>
                      <Form.Control
                        onChange={(e) => props.setNotContainsPreviewModifier(e.target.value)}
                        className="primary "
                        size="sm"
                        value={props.notContainsPreviewModifier}
                        as="select"
                        style={{ width: "70px" }}>
                        <option value="and">and</option>
                        <option value="or">or</option>
                      </Form.Control>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="p-3 mb-4" style={{ backgroundColor: "#F5F5F5" }}>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <p className="f16 visby-bold primary">Output preview:</p>
                    </Col>
                  </Row>
                  <Row className="d-flex mb-3 d-inline-block d-flex">
                    <Col style={{ marginRight: "35px" }} md={1}>
                      <p className="f16 nunito-regular primary bold pr-3">Contains:</p>
                    </Col>
                    <Col>
                      {props.containsPreviewModifier === "and"
                        ? props.containsTerms
                          .toString()
                          .replaceAll(",", " and ")
                          .split(" ")
                          .map((text) => {
                            return text === "and" ? (
                              <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-and d-inline-block">
                                and
                              </span>
                            ) : (
                              <span key={uuidv4()} className="f16 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                            );
                          })
                        : props.containsTerms
                          .toString()
                          .replaceAll(",", " or ")
                          .split(" ")
                          .map((text) => {
                            return text === "or" ? (
                              <span style={{ marginBottom: "3px" }} key={uuidv4()} className="d-inline-block styled-or">
                                or
                              </span>
                            ) : (
                              <span key={uuidv4()} className="d-inline-block f16 nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                            );
                          })}
                    </Col>
                  </Row>
                  <Row className="d-flex mb-2 d-inline-block d-flex">
                    <Col style={{ marginRight: "35px" }} md={2}>
                      <p style={{ whiteSpace: "nowrap" }} className="f16 nunito-regular  danger bold pr-3">
                        Does not contain:
                      </p>
                    </Col>
                    <Col>
                      {props.notContainsPreviewModifier === "and"
                        ? props.notContainsTerms
                          .toString()
                          .replaceAll(",", " and ")
                          .split(" ")
                          .map((text) => {
                            return text === "and" ? (
                              <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-and d-inline-block">
                                and
                              </span>
                            ) : (
                              <span key={uuidv4()} className="f16 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                            );
                          })
                        : props.notContainsTerms
                          .toString()
                          .replaceAll(",", " or ")
                          .split(" ")
                          .map((text) => {
                            return text === "or" ? (
                              <span style={{ marginBottom: "3px" }} key={uuidv4()} className="d-inline-block styled-or">
                                or
                              </span>
                            ) : (
                              <span key={uuidv4()} className="d-inline-block f16 nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                            );
                          })}
                    </Col>
                  </Row>
                  <Row className="d-flex mt-3 mb-2 d-inline-block d-flex">
                    <Col>
                      <p style={{ whiteSpace: "nowrap" }} className="f16 visby-bold  primary mb-2">
                        Test a campaign name:
                      </p>
                      <div className="d-flex">
                        <Form.Control
                          size="md"
                          onChange={(e) => setTestString(e.target.value)}
                          placeholder={"Add the name of a campaign here"}
                          value={testString}
                          style={testString != "" ? (
                            testStringMatches ? {
                              background: "rgba(0, 200, 0, .25)"
                            } : {
                              background: "rgba(200, 0, 0, .25)"
                            }
                          ) : {}}
                        />
                        <div style={{ height: "38px", width: "38px" }}>
                          {testString != "" && (
                            testStringMatches ? (
                              <i className="fas fa-check text-success" style={{ position: "relative", top: "5px", left: "calc(50% - 5px)" }}></i>
                            ) : (
                              <i className="fas fa-times text-danger" style={{ position: "relative", top: "5px", left: "calc(50% - 5px)" }}></i>
                            )
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col>
              <div className="px-md-3 px-0">
                <p className="visby-bold f16 primary pb-2">Instructions:</p>
                <p className="nunito-regular f14 primary pb-2">
                  First, configure your terms that you want to contain (or exclude) by typing the term in the top corresponding field and clicking "Add term".
                </p>
                <p className="nunito-regular f14 primary pb-2">
                  Then, select your modifier for each column to determine how those groups of terms will affect tracking. Choosing 'and' will detect and track
                  results in which <span className="bold">every</span> listed term is included. Choosing 'or' will detect and track{" "}
                  <span className="bold">any</span> result with <span className="bold">at least one</span> of the listed terms.
                </p>
                <p className="nunito-regular f14 primary pb-2">
                  Finally, read (and re-read) your output to ensure your "sentence structure" is correct. Remember, 'and' will only track results with{" "}
                  <span className="bold">all</span> terms, while 'or' will track results with <span className="bold">any</span> term.
                </p>
              </div>
            </Col>
          </Row>
          <hr className="divider"></hr>
          <Row>
            {props.platformType === "Social" ? (
              <Col className="d-flex" style={{ gap: "20px" }}>
                <div>
                  <p className="d-inline-block visby-bold primary f16 mb-3">Facebook Objective </p>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="Here you can set the objective for facebook conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
                    inline={true}
                  />
                  <Form.Control
                    className="primary mb-2"
                    size="md"
                    as="select"
                    value={conversionObjective}
                    onChange={(e) => setConversionObjective(e.target.value)}
                    style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
                    {Object.keys(props.facebook_conversion_objectives).map((objectiveName) => {
                      const objectiveInt = props.facebook_conversion_objectives[objectiveName];
                      return (
                        <option key={objectiveInt} value={objectiveName}>
                          {capitalize(objectiveName.split("_").join(" "))}
                        </option>
                      );
                    })}
                  </Form.Control>
                  {conversionObjective == "custom_conversions" && (
                    <CustomConversions customConversions={customConversions} setCustomConversions={setCustomConversions} />
                  )}
                </div>
                <div>
                  <p className="d-inline-block visby-bold primary f16 mb-3">Tiktok Objective </p>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
                    inline={true}
                  />
                  <Form.Control
                    className="primary mb-2"
                    size="md"
                    as="select"
                    value={tiktokConversionObjective}
                    onChange={(e) => setTiktokConversionObjective(e.target.value)}
                    style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
                    {Object.keys(props.tiktok_conversion_objectives).map((objectiveName) => {
                      const objectiveInt = props.tiktok_conversion_objectives[objectiveName];
                      return (
                        <option key={objectiveInt} value={objectiveName}>
                          {capitalize(objectiveName.split("_").join(" "))}
                        </option>
                      );
                    })}
                  </Form.Control>
                </div>
              </Col>
            ) : (
              <Col>
                <div className="mb-3">
                  <span className="visby-bold primary f16">Custom Conversions</span>
                  <span>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message={
                      <div style={{ textAlign: "center" }}>
                        <p>To get a Conversion Action ID, go to Google Ads and open the Tools & Settings menu from the top right of the navbar. In the Measurement column, select Conversions. Next, select the conversion action from the list that appears. Once you have selected a conversion action, check the final URL of the page and look for the 'ctId' parameter. This will be equal to the Conversion Action's ID.</p>
                        <img src="https://digital-position.monday.com/protected_static/2205640/resources/991799417/large-conversion-action-ctid.jpg" alt="Conversion Aciton ID" style={{ maxWidth: "450px", display: "block", margin: "0 auto", marginTop: "10px" }}/>
                      </div>
                    }
                    inline={true}
                  />
                  </span>
                </div>
                <ConversionActionIds
                  cg={true}
                  conversionActionsEnabled={conversionActionsEnabled}
                  onChange={() => {
                    setConversionActionsEnabled(!conversionActionsEnabled);
                  }}
                  option="custom conversions"
                  conversionActions={conversionActions}
                  setConversionActions={setConversionActions}
                />
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className="mt-4">
            <Col>
              <Button
                style={{
                  paddingLeft: "35px",
                  paddingRight: "35px",
                }}
                className="my-3 mr-2 btn-lg cancel-button"
                onClick={() => setShowBox(false)}>
                Cancel
              </Button>

              <Button
                style={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                }}
                variant="success"
                className="my-3 btn-lg"
                onClick={handleSumbit}
                >
                Save campaign group
              </Button>
            </Col>
            {errorText.length > 0 && (
              <Col xs={12}>
                <Alert variant="danger">
                  {errorText.map((error, index) => {
                    return <p key={index}>{error}</p>;
                  }
                  )}
                </Alert>
              </Col>
            )}
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
